import styles from "./index.module.scss";
export const SettingsHeader = ({ name }) => {
  return <div className={styles.settings_header}>{name}</div>;
};
